import { render, staticRenderFns } from "./ClassTimer.vue?vue&type=template&id=a1aedd9a&"
import script from "./ClassTimer.vue?vue&type=script&lang=js&"
export * from "./ClassTimer.vue?vue&type=script&lang=js&"
import style0 from "./ClassTimer.vue?vue&type=style&index=0&id=a1aedd9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports